export default {
  alternativeNext: {
    id: 'alternative-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'alternative-previous',
    defaultMessage: 'Previous',
  },
  alternativeClose: {
    id: 'alternative-close',
    defaultMessage: 'Close',
  },
  desktopWeeks: {
    id: 'cms_countdown_banner_desktop_weeks',
    defaultMessage: 'wk',
  },
  desktopDays: {
    id: 'cms_countdown_banner_desktop_days',
    defaultMessage: 'dy',
  },
  desktopHours: {
    id: 'cms_countdown_banner_desktop_hours',
    defaultMessage: 'hr',
  },
  desktopMinutes: {
    id: 'cms_countdown_banner_desktop_minutes',
    defaultMessage: 'min',
  },
  desktopSeconds: {
    id: 'cms_countdown_banner_desktop_seconds',
    defaultMessage: 'sec',
  },
  mobileWeeks: {
    id: 'cms_countdown_banner_mobile_weeks',
    defaultMessage: 'w',
  },
  mobileDays: {
    id: 'cms_countdown_banner_mobile_days',
    defaultMessage: 'd',
  },
  mobileHours: {
    id: 'cms_countdown_banner_mobile_hours',
    defaultMessage: 'h',
  },
  mobileMinutes: {
    id: 'cms_countdown_banner_mobile_minutes',
    defaultMessage: 'm',
  },
  mobileSeconds: {
    id: 'cms_countdown_banner_mobile_seconds',
    defaultMessage: 's',
  },
}
